<div *ngIf="timeRestriction" fxLayout="column" [@.disabled]="disableAnimation" class="width-100">
  <num-header-description>
    {{ 'SHARED_FILTER.TIMERESTRICTION.TITLE' | translate }}
  </num-header-description>
  <div fxLayout="row" fxLayoutAlign="start" class="width-100">
    <!--Time restriction Filter type-->
    <num-timerestriction-type-selector
      [type]="this.timeRestriction.getType()"
      (timeRestrictionTypeChanged)="onTimeRestrictionOptionChange($event)"
    >
    </num-timerestriction-type-selector>

    <!--Between Filter-->
    <ng-container *ngIf="selectedTimeRestrictionType === 'BETWEEN'">
      <num-between-filter
        class="width-100"
        (betweenFilterChanged)="emitSelectedTimeRestrictionInstance($event)"
        [betweenFilter]="timeRestriction"
      ></num-between-filter>
    </ng-container>

    <!--After, At, Before Filter-->
    <ng-container
      *ngIf="selectedTimeRestrictionType !== 'BETWEEN' && selectedTimeRestrictionType !== 'NONE'"
    >
      <num-before-filter
        class="width-100"
        [timeRestrictionType]="selectedTimeRestrictionType"
        [selectedDate]="timeRestriction.getAfterDate()"
        (timeRestrictionInstanceChanged)="emitSelectedTimeRestrictionInstance($event)"
      ></num-before-filter>
    </ng-container>
  </div>
</div>
